import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel"];

  connect() {
    this.onKeydown = this.onKeydown.bind(this);
  }

  disconnect() {
    window.removeEventListener("keydown", this.onKeydown);
  }

  toggle(event) {
    event?.stopPropagation?.();
    const open = this.panelTarget.classList.contains("hidden");
    open ? this.open() : this.close();
  }

  open() {
    this.panelTarget.classList.remove("hidden");
    window.addEventListener("keydown", this.onKeydown);
  }

  close(event) {
    event?.stopPropagation?.();
    this.panelTarget.classList.add("hidden");
    window.removeEventListener("keydown", this.onKeydown);
  }

  stop(event) {
    event.stopPropagation();
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close();
  }
}
